export default "/easyecom.2ad9ba23-3714f3.jpeg";